import { render, staticRenderFns } from "./DocLink.vue?vue&type=template&id=54adefb8"
import script from "./DocLink.ts?vue&type=script&lang=ts&external"
export * from "./DocLink.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports